import { Card, Col, Row, Table } from "antd";
import React from "react";
import logoImg from "../../images/logo.jpg";
import { ColumnProps } from "antd/es/table";
import "./style.css";

const Index = () => {
  const dataSource = [
    {
      key: "1",
      a1: "0001",
      a2: "31000901",
      a3: "某经销商A",
      a4: "A01B02C01",
      a5: "王**",
      a6: "A",
      a7: "400,000",
      a8: "1200,000",
      a9: "12%",
    },
    {
      key: "2",
      a1: "0002",
      a2: "31000902",
      a3: "某经销商B",
      a4: "A01B02C01",
      a5: "张**",
      a6: "A",
      a7: "400,000",
      a8: "1200,000",
      a9: "9%",
    },
    {
      key: "3",
      a1: "0003",
      a2: "31000903",
      a3: "某经销商C",
      a4: "A01B02C01",
      a5: "李**",
      a6: "A",
      a7: "400,000",
      a8: "1200,000",
      a9: "14%",
    },
  ];

  const columns: ColumnProps<any>[] = [
    {
      title: "项目编号",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "经销商编号",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "经销商名称",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "社会统一信用代码",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "法人姓名",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "风控评级",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "月平均进货额",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "融资金额",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "期望利率（年化）",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
  ];

  return (
    <div className="homes">
      {/* <Card>
        <header>
          <div className="img">
            <img src={logoImg} alt="" />
          </div>
          <div className="text">
            <div className="title">你好，管理员</div>
            <div className="desc">最近登录：2020-04-05 12：31：37</div>
          </div>
        </header>
      </Card> */}

      <Card
        title="订单贷资产"
        style={{ marginTop: "20px" }}
        className="messages"
      >
        <Row gutter={24} className="rows">
          <Col span={24} className="cols">
            <Card>
              {/* <h2 style={{ textAlign: "center" }}>订单贷资产</h2> */}
              <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Index;
